<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              type="outline-neutral"
              @click="mode = 'view'"
              class="min-button mr-2"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button"
              v-if="mode === 'edit'"
              @click="saveSettings()"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid profile mb-5 forms">
      <div class="row">
        <div class="col-xl-12">
          <tabs
            tabNavClasses="tabs-home justify-content-around tab-profiles"
            :value="tabActive"
            type="primary"
          >
            <tab-pane
              class="tabs-home-content"
              id="global"
              title="Global"
              ref="global"
            >
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                  <div class="card">
                    <h2 class="subtitle">Company Info</h2>

                    <div class="row">
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">DBA Name</span>
                          <span class="content-block"
                            >{{ entityDetails.businessDetails.name }}
                          </span>
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Legal Name</span>
                          <span class="content-block"
                            >{{ entityDetails.businessDetails.name }}
                          </span>
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">VAT Number</span>
                          <span
                            class="content-block"
                            v-if="entityDetails.businessDetails.vatNumber"
                            >{{ entityDetails.businessDetails.vatNumber }}
                          </span>
                          <span class="content-block" v-else
                            >Not Available</span
                          >
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">License Number</span>
                          <span
                            class="content-block"
                            v-if="entityDetails.businessDetails.licenseNumber"
                            >{{ entityDetails.businessDetails.licenseNumber }}
                          </span>
                          <span class="content-block" v-else
                            >Not Available</span
                          >
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Email</span>
                          <span class="content-block"
                            >{{ entityDetails.authentication.email }}
                          </span>
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Phone Number</span>
                          <span class="content-block"
                            >{{
                              getContactNumber(
                                true,
                                entityDetails.contactPerson.phoneNumbers
                              )
                            }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Address</span>
                          <span class="content-block"
                            >{{ entityDetails.address.street }},
                            {{ entityDetails.address.city }},
                            {{ entityDetails.address.state }},
                            {{ entityDetails.address.zipCode }},
                            {{ entityDetails.address.country }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-9 col-lg-9 ">
                  <div class="card">
                    <h2 class="subtitle">Global Info</h2>

                    <div v-if="mode === 'edit'">
                      <div class="row mt-2">
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Time Zone"
                            placeholder="Time Zone"
                            v-model="settings.timeZone"
                            id="time_zone"
                            name="time_zone"
                          >
                            <el-option
                              v-for="(option, index) in timezones"
                              :value="option"
                              :label="option"
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Time Format"
                            placeholder="Time Format"
                            v-model="settings.timeFormat"
                            id="time_format"
                            name="time_format"
                          >
                            <el-option
                              v-for="option in timeformat"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Date Format"
                            placeholder="Date Format"
                            v-model="settings.dateFormat"
                            id="date_format"
                            name="date_format"
                          >
                            <el-option
                              v-for="option in dateformat"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Measurement Unit"
                            placeholder="Measurement Unit"
                            v-model="settings.measurementUnit"
                            id="measurement"
                            name="measurement"
                          >
                            <el-option
                              v-for="option in units"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Currency"
                            placeholder="Currency"
                            v-model="settings.currency"
                            id="currency"
                            name="currency"
                          >
                            <el-option
                              v-for="coin in currencies"
                              :value="coin.code"
                              :label="coin.label"
                              :key="coin.code"
                            >
                              <span class="coin-left">
                                {{ coin.label }}
                              </span>
                              <span class="coin-right">
                                {{ coin.symbol }}
                              </span>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Language"
                            placeholder="Language"
                            v-model="settings.language"
                            id="Language"
                            name="Language"
                          >
                            <el-option
                              v-for="option in languages"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-else>
                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Time Zone</span>
                          <span class="content-block"
                            >{{ settings.timeZone }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Time Format</span>
                          <span class="content-block"
                            >{{ getTimeFormat(settings.timeFormat) }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Date Format</span>
                          <span class="content-block"
                            >{{ getDateFormat(settings.dateFormat) }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Measurement Unit</span>
                          <span class="content-block"
                            >{{ getUnit(settings.measurementUnit) }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Currency</span>
                          <span class="content-block"
                            >{{ getCurrenciesLabel(settings.currency) }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="data-block">
                          <span class="title-block">Language</span>
                          <span class="content-block"
                            >{{ getLanguage(settings.language) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <h2 class="subtitle">Default Settings</h2>

                    <div v-if="mode === 'edit'">
                      <div class="row mt-2">
                        <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            label="Distance for rate calculation"
                            placeholder="Distance"
                            id="distance_max"
                            name="distance_max"
                            v-model="settings.maximumDistance"
                            input-group-classes="input-group-merge"
                            :tooltip="true"
                            contentTooltip="For rides less than the Kilometers in rate
                            calculation, RhomTrip will calculate Area + extra km
                            for rides greater than the Kilometers in rate
                            calculation, RhomTrip will calculate Base price +
                            extra km"
                          >
                            <el-option
                              v-for="option in areaRadius"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                            <template slot="suffix">{{
                              getUnit(settings.measurementUnit)
                            }}</template>
                          </WSelect>
                        </div>
                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 switch-lg"
                        >
                          <label for="title" class="title-label">Taxes</label>
                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                            class="mb-0"
                          >
                            <b-form-radio-group
                              v-model="settings.taxes.type"
                              :aria-describedby="ariaDescribedby"
                              id="settings_taxes_type"
                              name="settings_taxes_type"
                              buttons
                              button-variant="outline-neutral pc-1"
                              size="md"
                            >
                              <b-form-radio value="tax">TAX</b-form-radio>

                              <b-form-radio value="vat">VAT</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                          <BaseNumberInput
                            v-model.number="settings.taxes.value"
                            :label="
                              `Value ${
                                settings.taxes.type === 'tax' ? 'TAX' : 'VAT'
                              }`
                            "
                            placeholder="Value"
                            id="customer_markup"
                            name="customer_markup"
                            class="input-append"
                          >
                            <template slot="append">%</template>
                          </BaseNumberInput>
                        </div>
                      </div>
                    </div>

                    <div v-else>
                      <div class="row ">
                        <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="data-block">
                            <span class="title-block"
                              >Distance for rate calculation</span
                            >
                            <span class="content-block"
                              >{{ settings.maximumDistance }}
                              {{ getUnit(settings.measurementUnit) }}
                            </span>
                          </div>
                        </div>
                        <div
                          class="col-xl-2 col-lg-3 col-md-2 col-sm-2 col-4 switch-lg"
                        >
                          <div class="data-block">
                            <span class="title-block">Taxes</span>
                            <span class="content-block uppercase"
                              >{{ settings.taxes.type }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-2 col-sm-3 col-6">
                          <div class="data-block">
                            <span class="title-block">{{
                              `Value ${
                                settings.taxes.type === "tax" ? "TAX" : "VAT"
                              }`
                            }}</span>
                            <span class="content-block"
                              >{{ settings.taxes.value }} %
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card">
                    <h2 class="subtitle">
                      Corporate Image
                      <el-popover
                        placement="top"
                        trigger="hover"
                        width="300"
                        v-if="mode === 'edit'"
                      >
                        <p class="form-control-label mb-2">
                          <strong>Corporate image</strong>
                        </p>
                        <p class="text-justify f1 lh-f1 mb-0">
                          Activate to personalize the app and notifications with
                          your Company Settings.
                        </p>

                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </h2>

                    <div v-if="mode === 'edit'">
                      <div class="row ">
                        <div
                          class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                        >
                          <span class="d-block mb-2"
                            >Customize the app and notifications with your brand
                          </span>
                        </div>
                        <div
                          class="col-xl-6 col-lg-6 col-md-4 col-sm-3 col-4 align-self-center"
                        >
                          <base-switch
                            class="d-inline-flex"
                            v-model="settings.permissions.brand"
                          ></base-switch>
                        </div>
                      </div>
                    </div>

                    <div v-else>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-8 col-sm-9 col-8 align-self-center"
                        >
                          <span class="d-block mb-2"
                            >Customize the app and notifications with your brand
                          </span>
                        </div>
                        <div
                          class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4 align-self-center text-center"
                        >
                          <div
                            class="badge-status badge-success mb-2"
                            v-if="settings.permissions.brand"
                          >
                            <span>Active</span>
                          </div>

                          <div class="badge-status badge-danger mb-2" v-else>
                            <span>Inactive</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="Brand"
              title="Brand"
              ref="Brand"
              :disabledTab="!settings.permissions.brand"
              msgDisabled="Option unavailable: Activate Corporate Image"
            >
              <div v-if="mode === 'edit'">
                <div class="row">
                  <div class="col-xl-5 col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12 pb-3">
                          <h2 class="subtitle">
                            Logos
                          </h2>
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-5 col-md-5 col-sm-6 col-12 pb-3"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Default
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <ul class="ul-pop">
                                      <li>Logo in colors</li>
                                      <li>Transparent Background</li>
                                      <li>
                                        Minimum Dimensions Required: 150 x 31 px
                                      </li>
                                      <li>
                                        Allowed Dimensions: 300 x 64 px
                                      </li>
                                      <li>Maximum Size: 2MB</li>
                                      <li>Allowed Formats: .PNG</li>
                                    </ul>
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </span>
                              </div>

                              <div class="logo-load-default">
                                <div
                                  class="image"
                                  @click="uploadLogos('default')"
                                >
                                  <div class="img-logo-default">
                                    <LazyImage
                                      v-if="settings.brand.logos.default"
                                      :src="settings.brand.logos.default"
                                      imgClasses="logo-default"
                                    />

                                    <div
                                      v-else
                                      class="box-upload"
                                      :class="{
                                        invalid:
                                          $v.settings.brand.logos.default.$error
                                      }"
                                    >
                                      <i class="flaticon-arrow-up mr-1"></i>
                                      <span>Upload your Logo</span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="remove mb-3"
                                  v-if="settings.brand.logos.default"
                                  @click="removeLogo('default')"
                                >
                                  <span> Remove</span>
                                  <i class="flaticon-delete ml-1"></i>
                                </div>

                                <div
                                  class="invalid-feedback"
                                  v-if="$v.settings.brand.logos.default.$error"
                                >
                                  Upload your logo
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-12 pb-3"
                            >
                              <div class="data-block">
                                <span class="title-block"
                                  >Favicon
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                    class="curp"
                                  >
                                    <ul class="ul-pop">
                                      <li>Logo Symbol in colors</li>
                                      <li>Transparent Background</li>
                                      <li>
                                        Minimum Dimensions: 60 x 60 px
                                      </li>
                                      <li>
                                        Allowed Dimensions: 300 x 300 px
                                      </li>
                                      <li>Maximum Size: 2MB</li>
                                      <li>Allowed Formats: PNG</li>
                                    </ul>
                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      <span>?</span>
                                    </div>
                                  </el-popover>
                                </span>
                              </div>

                              <div class="image-load-favicon">
                                <div
                                  class="image"
                                  @click="uploadLogos('favicon')"
                                >
                                  <div class="img-logo-favicon">
                                    <LazyImage
                                      v-if="settings.brand.logos.favicon"
                                      :src="settings.brand.logos.favicon"
                                      imgClasses="logo-favicon"
                                    />

                                    <div class="box-upload-favicon" v-else>
                                      <i class="flaticon-arrow-up"></i>
                                      <span>Upload your Favicon</span>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="remove mb-3"
                                  v-if="settings.brand.logos.favicon"
                                  @click="removeLogo('favicon')"
                                >
                                  <span> Remove</span>
                                  <i class="flaticon-delete ml-1"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12 pb-3">
                          <h2 class="subtitle">
                            Colors
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                            >
                              <span>
                                This represents your brand's colors and is
                                usually part of your company's visual identity.
                                This color will be used to highlight important
                                and interactive elements in email
                                communications, such as:</span
                              >

                              <ul class="ul-pop mt-2">
                                <li>Primary action buttons</li>
                                <li>Interactive links</li>
                                <li>Visual indicators</li>
                                <li>Hover or focus states</li>
                                <li>
                                  Decorative or graphic elements
                                </li>
                                <li>Progress or ongoing actions"</li>
                              </ul>
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </h2>
                          <div class="row">
                            <div class=" col-12 mb-2">
                              <div
                                class="form__field d-inline-flex align-items-center"
                              >
                                <div class="form__input">
                                  <v-swatches
                                    v-model="settings.brand.colors.primary"
                                    :swatches="colors"
                                    close-on-select
                                    popover-x="left"
                                    popover-y="bottom"
                                    shapes="circles"
                                    swatch-size="32"
                                    row-length="8"
                                    show-fallback
                                    fallback-input-type="color"
                                    :trigger-style="{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '50%'
                                    }"
                                    @input="getTextColorButtonBrand()"
                                  ></v-swatches>
                                </div>
                                <label
                                  class="title-label-np d-inline-flex ml-2 align-items-center"
                                >
                                  Brand Color
                                </label>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="row">
                                <div
                                  class="col-xl-7 col-lg-6 col-md-7 col-sm-7 col-8 align-self-center"
                                >
                                  <span class="d-block mb-2"
                                    >Use brand color in the App theme
                                  </span>
                                </div>
                                <div
                                  class="col-xl-3 col-lg-4 col-md-4 col-sm-5 col-4 align-self-center"
                                >
                                  <base-switch
                                    v-model="settings.brand.colors.inTheme"
                                    @input="getBrandTheme()"
                                  ></base-switch>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12 pb-3">
                          <h2 class="subtitle">
                            App Theme
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                            >
                              <span>
                                Change the appearance of the app according to
                                your preferences.</span
                              >

                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </h2>
                          <themeModel
                            :color="settings.brand.theme.color"
                          ></themeModel>
                        </div>

                        <div class=" col-12 mb-2">
                          <div
                            class="form__field d-inline-flex align-items-center"
                          >
                            <div class="form__input">
                              <v-swatches
                                v-model="settings.brand.theme.color"
                                :swatches="colors"
                                close-on-select
                                popover-x="left"
                                popover-y="bottom"
                                shapes="circles"
                                swatch-size="32"
                                row-length="8"
                                show-fallback
                                fallback-input-type="color"
                                :trigger-style="{
                                  width: '32px',
                                  height: '32px',
                                  borderRadius: '50%'
                                }"
                                :disabled="settings.brand.colors.inTheme"
                              ></v-swatches>
                            </div>
                            <label
                              class="title-label-np d-inline-flex ml-2 align-items-center"
                            >
                              Theme Color
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-12 align-self-center ">
                          <h2 class="subtitle">
                            Pickup Sign
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                            >
                              <span
                                >For any pickup, the driver will greet
                                passenger(s) upon arrival with a sign with their
                                name</span
                              >
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-7 col-8 align-self-center"
                        >
                          <span class="d-block mb-2"
                            >Branded name-Pickup Sign
                          </span>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 align-self-center"
                        >
                          <base-switch
                            v-model="settings.brand.pickupSign"
                            :disabled="settings.brand.logos.default === ''"
                          ></base-switch>
                        </div>
                      </div>

                      <div class="row justify-content-center mb-3">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-5 col-8"
                        >
                          <div class="box-pickup">
                            <img
                              v-if="
                                settings.brand.logos.default &&
                                  settings.brand.pickupSign
                              "
                              :src="settings.brand.logos.default"
                              alt="logo"
                            />
                            <img
                              v-else
                              :src="
                                require('rhomtrip_assets/src/img/brand/logo-rhomtrip-1p300.png')
                              "
                              alt="logo"
                            />
                            <span>Mrs. Helen White</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="mode === 'view'">
                <div class="row">
                  <div class="col-xl-5 col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12">
                          <h2 class="subtitle">
                            Logos
                          </h2>
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-5 col-md-5 col-sm-6 col-12 pb-3"
                            >
                              <div class="data-block">
                                <span class="title-block">Default </span>
                              </div>

                              <div class="logo-load-default preview">
                                <div class="image">
                                  <div class="img-logo-default">
                                    <img
                                      <LazyImage
                                      v-if="settings.brand.logos.default"
                                      :src="settings.brand.logos.default"
                                      imgClasses="logo-default"
                                    />

                                    <div
                                      v-else
                                      v-bind:style="{
                                        backgroundImage:
                                          'url(' + noPreviewView + ')'
                                      }"
                                      class="logo-default  preview"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-4 col-lg-5 col-md-5 col-sm-6 col-12 pb-3"
                            >
                              <div class="data-block">
                                <span class="title-block">Favicon </span>
                              </div>

                              <div class="image-load-favicon preview">
                                <div class="image">
                                  <div class="img-logo-favicon">
                                    <LazyImage
                                      v-if="settings.brand.logos.favicon"
                                      :src="settings.brand.logos.favicon"
                                      imgClasses="logo-favicon"
                                    />
                                    <div
                                      v-else
                                      v-bind:style="{
                                        backgroundImage:
                                          'url(' + noPreviewView + ')'
                                      }"
                                      class="logo-favicon preview"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12 pb-3">
                          <h2 class="subtitle">
                            Colors
                          </h2>
                          <div class="row">
                            <div class=" col-12 mb-2">
                              <div class="d-flex align-items-center">
                                <div
                                  class="color-circle d-inline-flex"
                                  v-bind:style="{
                                    'background-color':
                                      settings.brand.colors.primary
                                  }"
                                ></div>
                                <label
                                  class="title-label-np d-inline-flex ml-2 mb-0"
                                >
                                  Brand Color
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12 pb-3">
                          <h2 class="subtitle">
                            App Theme
                          </h2>
                          <themeModel
                            :color="settings.brand.theme.color"
                          ></themeModel>
                        </div>

                        <div class=" col-12 mb-2">
                          <div class="d-flex align-items-center">
                            <div
                              class="color-circle d-inline-flex"
                              v-bind:style="{
                                'background-color': settings.brand.theme.color
                              }"
                            ></div>
                            <label
                              class="title-label-np d-inline-flex ml-2 mb-0"
                            >
                              Theme Color
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-12 align-self-center ">
                          <h2 class="subtitle">
                            Pickup Sign
                          </h2>
                        </div>
                        <div class="col-xl-12">
                          <span class="d-block mb-2"
                            >Branded name-Pickup Sign
                          </span>
                        </div>
                      </div>

                      <div class="row justify-content-center mb-3">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-5 col-8"
                        >
                          <div class="box-pickup">
                            <img
                              v-if="
                                settings.brand.logos.default &&
                                  settings.brand.pickupSign
                              "
                              :src="settings.brand.logos.default"
                              alt="logo"
                            />
                            <img
                              v-else
                              :src="
                                require('rhomtrip_assets/src/img/brand/logo-rhomtrip-1p300.png')
                              "
                              alt="logo"
                            />
                            <span>Mrs. Helen White</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="Notifications"
              title="Notifications"
              ref="Notifications"
              :disabledTab="!settings.permissions.brand"
              msgDisabled="Option unavailable: Activate Corporate Image"
            >
              <div v-if="mode === 'edit'">
                <div class="row">
                  <div
                    class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12">
                          <h2 class="subtitle mb-4">
                            Info Notifications / Emails
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                            >
                              <span>
                                This information is used in the header, body and
                                footer of emails notifications and in the
                                Voucher.
                                <br /><br />
                                If you leave it blank, the Rhomtrip information
                                will be displayed by default.
                              </span>
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </h2>
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <base-input
                                v-model="settings.entityDetails.pages.web"
                                id="website"
                                name="website"
                                label="Web Site"
                                placeholder="Web site"
                                :tooltip="true"
                                titleTooltip="Web Site"
                                contentTooltip="Enter full URL, including http or https.
                                                    <br />
                                                    <br />Ex:
                                                    <br />
                                                    <strong>https://www.rhomtrip.com/</strong>"
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <base-input
                                v-model="settings.entityDetails.pages.contact"
                                id="contact_page"
                                name="contact_page"
                                label="Contact Page / Whatsapp URL"
                                placeholder="Contact Page"
                                :tooltip="true"
                                titleTooltip="Contact Page Url"
                                contentTooltip="Enter full URL, including http or https.
                                    <br />
                                    <br />Ex:
                                    <br />
                                    <strong>https://www.rhomtrip.com/contact</strong>"
                                :error="
                                  $v.settings.entityDetails.pages.contact.$error
                                    ? `Enter Contact Page / Whatsapp URL`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <base-input
                                v-model="
                                  settings.entityDetails.contact.phoneNumber
                                "
                                id="ContactPhone"
                                name="ContactPhone"
                                label="Contact Phone"
                                placeholder="Contact Phone"
                                :tooltip="true"
                                titleTooltip="Contact Phone"
                                contentTooltip="Enter the contact phone number, including code zone
                                          <br />
                                          <br />Ex:
                                          <br />
                                          <strong>+37 28801604</strong>"
                                :error="
                                  $v.settings.entityDetails.contact.phoneNumber
                                    .$error
                                    ? `Enter Contact Phone`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <base-input
                                v-model="settings.entityDetails.contact.email"
                                id="Contact Email"
                                name="ContactEmail"
                                label="Contact Email"
                                placeholder="Contact Email"
                                :tooltip="true"
                                titleTooltip="Contact Email"
                                contentTooltip=" Enter the contact email address
                                                      <br />
                                                      <br />Ex:
                                                      <br />
                                                      <strong>booking@rhomtrip.com</strong>"
                                :error="
                                  $v.settings.entityDetails.contact.email.$error
                                    ? `Enter Contact Email`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 "
                            >
                              <base-input
                                v-model="
                                  settings.entityDetails.pages.termsConditions
                                "
                                id="website_terms_page"
                                name="website_terms_page"
                                placeholder="Web site"
                                label="Terms & Conditions URL Page"
                                :tooltip="true"
                                titleTooltip="Terms & Conditions URL Page"
                                contentTooltip="Enter full URL, including http or https.
                                                  <br />
                                                  <br />Ex:
                                                  <br />
                                                  <strong>https://www.rhomtrip.com/terms-conditions</strong>"
                              />
                            </div>

                            <div class="col-xl-12 col-12">
                              <label
                                for="colorCorporate"
                                class="title-label mb-2"
                              >
                                Important Note / Attention
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  width="300"
                                >
                                  <p class="form-control-label mb-2">
                                    <strong>Important Note / Attention</strong>
                                  </p>
                                  <p class="text-justify f1 lh-f1">
                                    Enter important and relevant information
                                    that you must include at the end as the last
                                    paragraph of the emails
                                    <br />
                                    <br />Ex:
                                    <br />
                                    <strong>
                                      For all services, before a No Show is
                                      considered and Driver released, contact
                                      passenger or RhomTrip by phone.
                                    </strong>
                                  </p>

                                  <div
                                    class="badge badge-primary"
                                    slot="reference"
                                  >
                                    ?
                                  </div>
                                </el-popover>
                              </label>

                              <el-input
                                v-model="settings.entityDetails.importantNote"
                                id="important_note"
                                name="important_note"
                                maxlength="5000"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 5 }"
                                show-word-limit
                              >
                              </el-input>
                              <div
                                class="invalid-feedback mt-0"
                                v-if="
                                  !$v.settings.entityDetails.importantNote
                                    .minLength ||
                                    $v.settings.entityDetails.importantNote
                                      .$error
                                "
                              >
                                Minimum 100 characteres
                              </div>
                            </div>

                            <div class="col-12">
                              <hr />

                              <div class="data-block">
                                <span class="title-block"
                                  >Social Media
                                  <el-popover
                                    placement="top"
                                    trigger="hover"
                                    width="300"
                                  >
                                    <p class="form-control-label mb-2">
                                      <strong>Social Media</strong>
                                    </p>
                                    <p class="text-justify f1 lh-f1">
                                      Enter only name user or ID user. Your name
                                      user is the last word located after the
                                      last bar of the url of the social network.
                                      <br />Ex:
                                      <strong>
                                        https://www.facebook.com/
                                        <span class="text-danger"
                                          >RhomTrip</span
                                        >
                                      </strong>
                                    </p>

                                    <div
                                      class="badge badge-primary"
                                      slot="reference"
                                    >
                                      ?
                                    </div>
                                  </el-popover>
                                </span>
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model="settings.socialmedia.facebook"
                                id="facebook"
                                name="facebook"
                                label="Facebook"
                                placeholder="Facebook"
                                :error="
                                  $v.settings.socialmedia.facebook.$error
                                    ? `Enter valid Facebook URL`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model="settings.socialmedia.twitter"
                                :error="
                                  $v.settings.socialmedia.twitter.$error
                                    ? `Enter valid Twitter URL`
                                    : ''
                                "
                                id="Twitter"
                                name="Twitter"
                                label="Twitter / X"
                                placeholder="Twitter"
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model="settings.socialmedia.instagram"
                                id="Instagram"
                                name="Instagram"
                                label="Instagram"
                                placeholder="Instagram"
                                :error="
                                  $v.settings.socialmedia.instagram.$error
                                    ? `Enter valid Instagram URL`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model="settings.socialmedia.linkedin"
                                :error="
                                  $v.settings.socialmedia.linkedin.$error
                                    ? `Enter valid LinkedIn URL`
                                    : ''
                                "
                                id="Linkedin"
                                name="Linkedin"
                                label="Linkedin"
                                placeholder="Linkedin"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-12 align-self-center">
                          <h2 class="subtitle">
                            Model template
                            <el-popover
                              placement="top"
                              trigger="hover"
                              width="300"
                              class="curp"
                            >
                              <span
                                >This is a sample of what the email template
                                sent to customers will look like.</span
                              >
                              <div class="badge badge-primary" slot="reference">
                                <span>?</span>
                              </div>
                            </el-popover>
                          </h2>
                        </div>

                        <div class=" col-12 mb-3 text-center">
                          <templateModel
                            :color="settings.brand.colors.primary"
                          ></templateModel>

                          <base-button
                            class="btn min-button lh-100 mt-3 no-mobile"
                            type="outline-secondary"
                            @click="modalpreview = true"
                          >
                            See Preview
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="mode === 'view'">
                <div class="row">
                  <div
                    class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-xl-12">
                          <h2 class="subtitle mb-4">
                            Info Notifications / Emails
                          </h2>
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Web Site
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.entityDetails.pages.web"
                                >
                                  {{ settings.entityDetails.pages.web }}
                                </span>

                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Contact Page / Whatsapp URL
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.entityDetails.pages.contact"
                                >
                                  {{ settings.entityDetails.pages.contact }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Contact Phone
                                </span>
                                <span
                                  class="content-block"
                                  v-if="
                                    settings.entityDetails.contact.phoneNumber
                                  "
                                >
                                  {{
                                    settings.entityDetails.contact.phoneNumber
                                  }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Contact Email
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.entityDetails.contact.email"
                                >
                                  {{ settings.entityDetails.contact.email }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div class="col-xl-12 col-12 ">
                              <div class="data-block">
                                <span class="title-block">
                                  Important Note / Attention
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.entityDetails.importantNote"
                                >
                                  {{ settings.entityDetails.importantNote }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Terms & Conditions URL Page
                                </span>
                                <span
                                  class="content-block"
                                  v-if="
                                    settings.entityDetails.pages.termsConditions
                                  "
                                >
                                  {{
                                    settings.entityDetails.pages.termsConditions
                                  }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div class="col-12">
                              <hr />

                              <div class="data-block">
                                <span class="title-block">Social Media </span>
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Facebook
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.socialmedia.facebook"
                                >
                                  {{ settings.socialmedia.facebook }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Twitter
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.socialmedia.twitter"
                                >
                                  {{ settings.socialmedia.twitter }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Instagram
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.socialmedia.instagram"
                                >
                                  {{ settings.socialmedia.instagram }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <div class="data-block">
                                <span class="title-block">
                                  Linkedin
                                </span>
                                <span
                                  class="content-block"
                                  v-if="settings.socialmedia.linkedin"
                                >
                                  {{ settings.socialmedia.linkedin }}
                                </span>
                                <span class="content-block" v-else
                                  >Not Available</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 box-flex"
                  >
                    <div class="card">
                      <div class="row">
                        <div class="col-12 align-self-center">
                          <h2 class="subtitle">
                            Model template
                          </h2>
                        </div>

                        <div class=" col-12 mb-3 text-center">
                          <templateModel
                            :color="settings.brand.colors.primary"
                          ></templateModel>

                          <base-button
                            class="btn min-button lh-100 mt-3 no-mobile"
                            type="outline-secondary"
                            @click="modalpreview = true"
                          >
                            See Preview
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane
              class="tabs-home-content"
              id="SMTP Configuration"
              title="SMTP Configuration"
              ref="SMTP Configuration"
            >
              <div v-if="mode === 'edit'">
                <div class="row">
                  <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="card">
                      <h2 class="subtitle mb-4 mr-2">
                        SMTP Configuration
                        <el-popover placement="top" trigger="hover" width="300">
                          <p class="form-control-label mb-2">
                            <strong>SMTP Configuration</strong>
                          </p>

                          <p class="text-justify f1 lh-f1">
                            By default, the system sends all email messages from
                            RhomTrip own email server. But you can change this
                            and make the system use your own server.
                          </p>

                          <div class="badge badge-primary" slot="reference">
                            ?
                          </div>
                        </el-popover>
                      </h2>

                      <div class="row">
                        <div class="col-lg-8 align-self-top">
                          <WSelect
                            placeholder="Email Provider"
                            v-model="settings.smtp.service"
                            filterable
                            label="Email Provider"
                            @input="setSmtpSettings()"
                            v-bind:class="{
                              'is-invalid': $v.settings.smtp.service.$error
                            }"
                            :error="
                              $v.settings.smtp.service.$error
                                ? 'Select a Email Provider'
                                : ''
                            "
                          >
                            <el-option
                              v-for="option in providersEmail"
                              :value="option.name"
                              :label="option.name"
                              :key="option.id"
                            ></el-option>
                          </WSelect>
                        </div>
                        <div class="col-lg-4 align-self-top">
                          <el-popover
                            placement="top"
                            trigger="hover"
                            width="300"
                          >
                            <p class="form-control-label mb-2">
                              <strong>SMTP Configuration</strong>
                            </p>

                            <ul class="ul-pop">
                              <li>
                                Access your SMTP Settings of your email account
                              </li>
                              <li>Set up your Host Name</li>
                              <li>
                                Enter the applicable Port to match your Host
                              </li>
                              <li>Enter your Username</li>
                              <li>Enter your Password</li>
                              <li>Optional: Select Require TLS/SSL.</li>
                            </ul>
                            <br />
                            <p class="text-justify f1 lh-f1 mb-0">
                              <strong> NOTE: </strong>This will depend on the
                              email provider you select.
                            </p>

                            <p class="mb-0 text-right">
                              <a
                                class="text-justify f1 lh-f1"
                                href="https://help.rhomtrip.com/rhomtrip-mobility/smtp-configuration/"
                                target="blank"
                                >Click here for help</a
                              >
                            </p>

                            <div class="badge badge-primary" slot="reference">
                              ?
                            </div>
                          </el-popover>
                        </div>
                        <div class="col-6">
                          <base-input
                            v-model="$v.settings.smtp.host.$model"
                            label="Server/Host Name"
                            placeholder="settings.smtp.gmail.com"
                            :error="
                              $v.settings.smtp.host.minLenght ||
                              $v.settings.smtp.host.$error
                                ? `Enter a Host Name Provider`
                                : ''
                            "
                          />
                        </div>

                        <div class="col-6">
                          <WSelect
                            placeholder="Port"
                            v-model="settings.smtp.port"
                            filterable
                            label="Port"
                            v-bind:class="{
                              'is-invalid': $v.settings.smtp.port.$error
                            }"
                            :error="
                              $v.settings.smtp.port.$error
                                ? 'Select a valid Port'
                                : ''
                            "
                          >
                            <el-option
                              v-for="(option, index) in ports"
                              :value="option.value"
                              :label="option.label"
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            placeholder="Connection Security Encryption"
                            v-model="$v.settings.smtp.secure.$model"
                            filterable
                            label="Connection Security 
                      "
                            v-bind:class="{
                              'is-invalid': $v.settings.smtp.secure.$error
                            }"
                            :error="
                              $v.settings.smtp.secure.$error
                                ? 'Select an Encryption'
                                : ''
                            "
                          >
                            <el-option
                              v-for="(option, index) in encryption"
                              :value="option.value"
                              :label="option.label"
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <WSelect
                            placeholder="Authentications Method"
                            v-model="settings.smtp.auth.type"
                            filterable
                            label="Authentications Method"
                            v-bind:class="{
                              'is-invalid': $v.settings.smtp.auth.type.$error
                            }"
                            :error="
                              $v.settings.smtp.auth.type.$error
                                ? 'Select an authentication'
                                : ''
                            "
                          >
                            <el-option
                              v-for="(option, index) in authentication"
                              :value="option.value"
                              :label="option.label"
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-12">
                          <base-input
                            v-model.trim="settings.smtp.auth.email"
                            id="company_email_notif"
                            name="company_email_notif"
                            placeholder="example@email.com"
                            :error="
                              !$v.settings.smtp.auth.email.email ||
                              $v.settings.smtp.auth.email.$error
                                ? `Enter  a valid email address.`
                                : ''
                            "
                            label="Email Notifications"
                            :tooltip="true"
                            titleTooltip="Email Notifications"
                            contentTooltip=' <p class="text-justify f1 lh-f1">
                          It is the email with which the notifications will be
                          sent, is used for all types of communication emails
                          between company and drivers / customers / suppliers.
                          The following notifications are sent from Email
                          Notifications:
                        </p>

                        <ul class="ul-pop">
                          <li>Reservation notifications</li>
                          <li>User invites</li>
                          <li>Driver invites</li>
                          <li>Trip summaries to customers and drivers</li>
                          <li>Copies of Trip summaries to company</li>
                        </ul>'
                          />
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <base-input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="Password"
                            v-model="settings.smtp.auth.password"
                            label="Password"
                            :error="
                              !$v.settings.smtp.auth.password.minLength ||
                              $v.settings.smtp.auth.password.$error
                                ? `Enter a valid Password`
                                : ''
                            "
                            autocomplete="off"
                            :tooltip="true"
                            titleTooltip="Password"
                            contentTooltip="Is the password of you email account. This is stored
                          in an encrypted and secure way, and will only be used
                          for sending notifications from RhomTrip. We do not
                          share or use this information for any other means, or
                          for any other purposes."
                          ></base-input>
                        </div>
                        <div class="col-12">
                          <base-input
                            v-model="$v.settings.smtp.auth.user.$model"
                            label="Company / Department Name"
                            placeholder="Company / Department Name"
                            :error="
                              $v.settings.smtp.auth.user.minLenght ||
                              $v.settings.smtp.auth.user.$error
                                ? `Enter a valid name`
                                : ''
                            "
                            :tooltip="true"
                            titleTooltip="Company / Department Name"
                            contentTooltip="  Is the name will be show when the notifications be
                          sent in the inbox email."
                          />
                        </div>

                        <div
                          class="col-12 alinmov2"
                          v-if="
                            settings.smtp.auth.password &&
                              settings.smtp.auth.email &&
                              settings.smtp.secure &&
                              settings.smtp.auth.user
                          "
                        >
                          <base-button
                            type="outline-neutral"
                            class="min-button mb-4"
                            :disabled="!sendEmail"
                            @click="testSMTPConfiguration()"
                          >
                            <i class="flaticon-checkmark"></i>Test Email
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="mode === 'view'">
                <div class="row">
                  <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="card">
                      <h2 class="subtitle">
                        SMTP Configuration
                      </h2>

                      <div class="row">
                        <div class="col-lg-8 col-12 align-self-top">
                          <div class="data-block">
                            <span class="title-block">
                              Email Provider
                            </span>
                            <span class="content-block">
                              {{ settings.smtp.service }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Server/Host Name
                            </span>
                            <span class="content-block">
                              {{ settings.smtp.host }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Port
                            </span>
                            <span class="content-block">
                              {{ settings.smtp.port }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Connection Security
                            </span>
                            <span class="content-block uppercase">
                              {{ settings.smtp.secure }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Authentications Method
                            </span>
                            <span class="content-block uppercase">
                              {{ settings.smtp.auth.type }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-12 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Email Notifications
                            </span>
                            <span class="content-block">
                              {{ settings.smtp.auth.email }}
                            </span>
                          </div>
                        </div>

                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                          <div class="data-block">
                            <span class="title-block">
                              Company / Department Name
                            </span>
                            <span class="content-block">
                              {{ settings.smtp.auth.user }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
    <modal :show.sync="modalpreview" size="lg" bodyClasses="pt-0 pb-0">
      <template slot="header">
        <h2 class="subtitle mb-4">Example Template New Reservation</h2>
      </template>
      <PreviewBrandTemplate :settings="settings" />
      <template slot="footer">
        <base-button type="secondary" size="sm" @click="modalpreview = false"
          >Close</base-button
        >
      </template>
    </modal>
  </section>
</template>

<script>
// @ is an alias to /src
const uploader = Uploader({
  apiKey: "public_FW25b8h4qXR3VoqLnET1Y8B4gp3T"
});
import { mapGetters, mapMutations } from "vuex";
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import VSwatches from "vue-swatches";
import endpoint from "../../Commons/Services/index";
import moment from "moment";

// import VSwatches from "vue-swatches";
import themeModel from "../../Components/model-theme.vue";
import templateModel from "../../Components/template-email-svg.vue";
import PreviewBrandTemplate from "../../Components/PreviewBrandTemplate.vue";
import {
  minLength,
  maxLength,
  email,
  numeric,
  requiredIf
} from "vuelidate/lib/validators";
import lodash from "lodash";
import Swal from "sweetalert2";
import { changePrimaryColor, goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Settings",
  data() {
    return {
      settings: {
        maximumDistance: 150,
        measurementUnit: "km",
        language: "",
        currency: "",
        timeZone: "",
        timeFormat: "",
        dateFormat: "",
        taxes: {
          type: "vat",
          value: 0
        },
        brand: {
          logos: {
            default: "",
            favicon: ""
          },
          colors: {
            primary: "#4b56a6",
            buttonText: "#FFFFFF",
            inTheme: false
          },
          theme: {
            color: "#4b56a6",
            buttonText: "#FFFFFF"
          }
        },
        socialmedia: {
          facebook: "",
          twitter: "",
          instagram: "",
          linkedin: ""
        },
        permissions: {
          brand: false,
          notifications: false
        },
        entityDetails: {
          company: {
            relationship: true,
            name: "",
            email: "",
            vatnumber: ""
          },
          contact: {
            phoneNumber: "",
            email: ""
          },
          pages: {
            web: "",
            contact: "",
            faq: "",
            termsConditions: ""
          },
          importantNote: ""
        },
        smtp: {
          service: "",
          host: "",
          port: "",
          secure: "",
          platform: "",
          auth: {
            type: "",
            email: "",
            password: "",
            user: "",
            refresh_token: "",
            access_token: "",
            client_id: "",
            client_secret: "",
            expires: ""
          }
        }
      },
      entityDetails: {
        contactPerson: {
          phoneNumbers: []
        },
        businessDetails: {
          image: "",
          licenseNumber: "",
          name: "",
          vatNumber: ""
        },
        authentication: {
          email: ""
        },
        address: {
          city: "",
          country: "",
          otherStreet: "",
          state: "",
          street: "",
          zipCode: ""
        }
      },
      theme: "Default",
      timezones: [],
      timeformat: [
        { value: "hh:mm A", label: "hh:mm a (12:30 PM)" },
        { value: "HH:mm", label: "hh:mm (14:30)" }
      ],
      dateformat: [
        {
          value: "DD-MMM-YYYY",
          label: `DD-MMM-YYYY (${moment().format("DD-MMM-YYYY")})`
        },
        {
          value: "DD/MM/YYYY",
          label: `DD/MM/YYYY (${moment().format("DD/MM/YYYY")})`
        },
        {
          value: "MM/DD/YYYY",
          label: `MM/DD/YYYY (${moment().format("MM/DD/YYYY")})`
        }
      ],
      units: [
        { value: "km", label: "Metric | Km" },
        { value: "miles", label: "Standard | Miles" }
      ],
      currencies: [
        { code: "USD", symbol: "$", label: "US Dollar" },
        { code: "EUR", symbol: "€", label: "Euro" },
        { code: "GBP", symbol: "£", label: "British Pound" },
        { code: "CHF", symbol: "₣", label: "Swiss Franc" },
        { code: "DKK", symbol: "kr", label: "Denmark Krone" },
        { code: "SEK", symbol: "kr", label: "Swedish Krona" },
        { code: "NOK", symbol: "kr", label: "Norwegian Krone" },
        { code: "ISK", symbol: "kr", label: "Icelandic Króna" },
        { code: "AED", symbol: "د.إ", label: "United Arab Emirates Dirham" }
      ],
      languages: [{ value: "en", label: "English" }],
      areaRadius: [
        { value: 50, label: "50" },
        { value: 100, label: "100" },
        { value: 150, label: "150" },
        { value: 200, label: "200" },
        { value: 250, label: "250" },
        { value: 300, label: "300" },
        { value: 350, label: "350" },
        { value: 400, label: "400" },
        { value: 450, label: "450" },
        { value: 500, label: "500" },
        { value: 550, label: "550" },
        { value: 600, label: "600" }
      ],
      operatorId: null,
      providersEmail: [
        {
          name: "Customizer",
          platform: "customizer",
          host: "",
          port: "465",
          authentication: [{ label: "LOGIN", value: "login" }],
          encryption: "starttls",
          help:
            "https://es.godaddy.com/help/usar-la-configuracion-del-imap-para-agregar-mi-workspace-email-a-un-cliente-4714"
        },
        {
          name: "Gmail / G-suite",
          platform: "gmail",
          host: "settings.settings.smtp.gmail.com",
          port: "465",
          encryption: "starttls",
          help:
            "https://help.rhomtrip.com/rhomtrip-mobility/smtp-configuration/",
          authentication: [{ label: "LOGIN", value: "login" }]
        }
      ],
      helpSmtp: "",
      ports: [
        { label: "465", value: "465" },
        { label: "587", value: "587" },
        { label: "588", value: "588" },
        { label: "2525", value: "2525" },
        { label: "8025", value: "8025" }
      ],
      encryption: [
        { label: "NONE", value: "none" },
        { label: "STARTTLS", value: "starttls" },
        { label: "TLS/SSL", value: "tls/ssl" }
      ],
      authentication: [
        //{ label: "AUTO", value: "AUTO" },
        //{ label: "CRAM-MD5", value: "CRAM-MD5" },
        //{ label: "LOGIN", value: "login" },
        //{ label: "NTLM", value: "NTLM" },
        //{ label: "PLAIN", value: "PLAIN" },
        //{ label: "OAUTH2", value: "oauth2" },
        //{ label: "XOAUTH2", value: "XOAUTH2" },
      ],
      sendEmail: true,
      noPreviewView: require("rhomtrip_assets/src/img/no-preview.png"),
      mode: "view",
      colors: [
        "#000000",
        "#666666",
        "#999999",
        "#980000",
        "#cc0000",
        "#f60000",
        "#E84B3C",
        "#e69138",
        "#F39C19",
        "#FFBB00",
        "#133217",
        "#028900",
        "#6aa84f",
        "#45818e",
        "#3c78d8",
        "#3F2AD4",
        "#25197F",
        "#0A0055",
        "#674ea7",
        "#8E43AD",
        "#A463BF",
        "#a64d79",
        "#CC0254",
        "#FF00A7"
      ],
      modalpreview: false,
      tabActive: "",
      settingId: null,
      configUpdated: false,
      settingsCopy: {}
    };
  },
  components: {
    WSelect,
    VueTelInput,
    VSwatches,
    themeModel,
    templateModel,
    PreviewBrandTemplate
  },
  async created() {
    var bread = [
      {
        text: "Settings",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.operatorId = this.getOperatorId(this.sesion);
    await this.getSettingsById(this.operatorId);
  },
  methods: {
    async getSettingsById(operatorId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.settings.services.getSettings(
          operatorId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let settings = data.data;
          this.settingId = settings._id;
          this.entityDetails.contactPerson.phoneNumbers =
            settings.relationship.contactPerson.phoneNumbers;

          this.entityDetails.businessDetails.image =
            settings.relationship.businessDetails.image;
          this.entityDetails.businessDetails.licenseNumber =
            settings.relationship.businessDetails.licenseNumber;
          this.entityDetails.businessDetails.name =
            settings.relationship.businessDetails.name;
          this.entityDetails.businessDetails.vatNumber =
            settings.relationship.businessDetails.vatNumber;
          this.entityDetails.authentication.email =
            settings.relationship.authentication.email;
          this.entityDetails.address = settings.relationship.address;

          this.settings.maximumDistance = settings.maximumDistance;
          this.settings.measurementUnit = settings.measurementUnit;
          this.settings.language = settings.language;
          this.settings.currency = settings.currency;
          this.settings.timeZone = settings.timeZone;
          this.settings.timeFormat = settings.timeFormat;
          this.settings.dateFormat = settings.dateFormat;
          this.settings.taxes = settings.taxes;

          this.settings.brand = settings.brand;
          this.settings.socialmedia = settings.socialmedia;
          this.settings.permissions = settings.permissions;
          this.settings.entityDetails = settings.entityDetails;
          this.settings.smtp = settings.smtp;
          this.settingsCopy = lodash.cloneDeep(this.settings);
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async saveSettings(router = null) {
      if (!this.$v.settings.$invalid) {
        await this.updateSettings(this.settingId, this.settings, router);
      } else {
        this.$v.settings.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateSettings(settingId, setting, router) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.settings.services.updateSettingById(
          settingId,
          setting,
          this.sesion.token
        );
        this.setLoad(false);
        this.configUpdated = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Services has been Saved",
            icon: "flaticon-check-3"
          });
          this.applySettingsChanges(setting);
          if (router) {
            this.$router.push(router);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    setSmtpSettings() {
      let data = this.providersEmail.find(
        elemen => elemen.name === this.settings.settings.smtp.service
      );
      this.settings.settings.smtp.service = data.name;
      this.settings.settings.smtp.host = data.host;
      this.settings.settings.smtp.port = data.port;
      this.settings.settings.smtp.auth.type = "login";
      this.settings.settings.smtp.platform = data.platform;
      this.authentication = data.authentication;
      this.settings.settings.smtp.secure = data.encryption;
      this.helpSmtp = data.help;
    },
    openUrl(url) {
      var windowWidth = window.innerWidth;
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=550,height=600,left=${windowWidth /
        2 -
        300},top=200`;
      let auth = window.open(url, "Auth2", params);
      localStorage.setItem("auth", auth);
    },
    async testSMTPConfiguration() {
      try {
        this.sendEmail = false;
        let { data } = await endpoint.settings.services.testSendEmail(
          this.operatorId
        );
        this.sendEmail = true;
        if (data.status) {
          let result = data.data;
          if (result.send) {
            this.$notify({
              type: "success",
              title: "Success!",
              message:
                "The SMTP settings has been tested. Now, you can send notifications with your email company.",
              icon: "flaticon-check-3"
            });
          } else {
            this.$notify({
              type: "warning",
              title: "Important!",
              message:
                "The email notification could not be sent, make sure your SMTP settings are correct. Please try again",
              icon: "flaticon-warning-1"
            });
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message:
              "The email notification could not be sent, make sure your SMTP settings are correct. Please try again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.sendEmail = true;
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "The email notification could not be sent, make sure your SMTP settings are correct. Please try again",
          icon: "flaticon-warning-1"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOperatorId(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    getContactNumber(status, phoneNumbers = []) {
      let contactNumber = phoneNumbers.find(
        phone => phone.preferred === status
      );
      if (contactNumber) {
        return contactNumber.number;
      } else {
        return "";
      }
    },
    async uploadLogos(logo) {
      try {
        let files = await this.uploaderOpen();
        if (files) {
          if (files.length) {
            let [file] = files;
            if (logo === "default") {
              this.settings.brand.logos.default = file.fileUrl;
            } else if (logo === "favicon") {
              this.settings.brand.logos.favicon = file.fileUrl;
            }
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async uploaderOpen() {
      return await uploader.open({
        maxFileCount: 1,
        maxFileSizeBytes: 2000000,
        mimeTypes: ["image/png"],
        multi: false,
        styles: {
          colors: {
            active: "#528fff",
            error: "#d23f4d",
            primary: "#4b56a6"
          }
        },
        editor: {
          images: {
            crop: false,
            preview: true
          }
        },
        path: {
          folderPath: "/users/partners/brand",
          folderPathVariablesEnabled: true
        }
      });
    },
    removeLogo(logo) {
      if (logo === "default") {
        this.settings.brand.logos.default = "";
      } else if (logo === "favicon") {
        this.settings.brand.logos.favicon = "";
      }
    },
    getTextColorButtonBrand() {
      this.settings.brand.colors.buttonText = this.getContrastColor(
        this.settings.brand.colors.primary
      );
      this.getBrandTheme();
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return { r, g, b };
    },
    getContrastColor(hex) {
      const { r, g, b } = this.hexToRgb(hex);
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 128 ? "#000000" : "#ffffff";
    },
    getBrandTheme() {
      if (this.settings.brand.colors.inTheme) {
        this.settings.brand.theme.color = this.settings.brand.colors.primary;
        this.settings.brand.theme.buttonText = this.getContrastColor(
          this.settings.brand.colors.primary
        );
      } else {
        this.settings.brand.theme.color = "#4b56a6";
        this.settings.brand.theme.buttonText = "#FFFFFF";
      }
    },
    getCurrenciesLabel(code) {
      const currency = this.currencies.find(item => item.code === code);
      return currency ? currency.label : "";
    },
    getLanguage(lang) {
      const language = this.languages.find(item => item.value === lang);
      return language ? language.label : "";
    },
    getUnit(unity) {
      const unit = this.units.find(item => item.value === unity);
      return unit ? unit.label : "";
    },
    getTimeFormat(time) {
      const format = this.timeformat.find(item => item.value === time);
      return format ? format.label : "";
    },
    getDateFormat(date) {
      const format = this.dateformat.find(item => item.value === date);
      return format ? format.label : "";
    },
    applySettingsChanges(settings) {
      this.setSettings({
        maximumDistance: settings.maximumDistance,
        measurementUnit: settings.measurementUnit,
        language: settings.language,
        currency: settings.currency,
        timeZone: settings.timeZone,
        timeFormat: settings.timeFormat,
        dateFormat: settings.dateFormat,
        layout: settings.settings,
        brand: settings.brand,
        permissions: settings.permissions
      });
      if (settings.permissions.brand) {
        changePrimaryColor(
          settings.brand.theme.color,
          settings.brand.theme.buttonText
        );
      } else {
        changePrimaryColor("#4b56a6", "#FFFFFF");
      }
    },
    ...mapMutations(["setLoad", "setSettings", "setItemsBread"])
  },
  computed: {
    ...mapGetters(["load", "sesion", "sigout"])
  },
  validations: {
    settings: {
      smtp: {
        service: {
          required: false
        },
        host: {
          required: false,
          minlength: minLength(4)
        },
        port: {
          required: false,
          minlength: minLength(2),
          numeric
        },
        secure: {
          required: false
        },
        auth: {
          type: {
            required: false
          },
          password: {
            required: false,
            minLength: minLength(4)
          },
          email: {
            email,
            required: false
          },
          user: {
            required: false
          }
        }
      },
      brand: {
        logos: {
          default: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            })
          }
        },
        colors: {
          primary: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            })
          },
          buttonText: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            })
          }
        },
        theme: {
          color: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            })
          },
          buttonText: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            })
          }
        }
      },
      entityDetails: {
        company: {
          name: {
            minLength: minLength(2),
            maxLength: maxLength(45)
          }
        },
        contact: {
          phoneNumber: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            }),
            minLength: minLength(7),
            maxLength: maxLength(25)
          },
          email: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            }),
            email
          }
        },
        pages: {
          contact: {
            required: requiredIf(function(value) {
              return this.settings.permissions.brand;
            }),
            maxLength: maxLength(100)
          }
        },
        importantNote: {
          minLength: minLength(100),
          maxlength: maxLength(5000)
        }
      },
      socialmedia: {
        facebook: {
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        twitter: {
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        instagram: {
          minLength: minLength(2),
          maxLength: maxLength(45)
        },
        linkedin: {
          minLength: minLength(2),
          maxLength: maxLength(45)
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let isEqual = lodash.isEqual(this.settings, this.settingsCopy);
      if (!isEqual && !this.configUpdated) {
        Swal.fire({
          title: "Important",
          html:
            "The Settings has been modified.<br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.saveSettings(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
</script>
